import React from "react";
import "./Project.css";
import project_1 from "./img/portfolio-1.jpg";
import project_2 from "./img/portfolio-2.jpg";
import project_3 from "./img/portfolio-3.jpg";
import project_4 from "./img/portfolio-4.jpg";
import project_5 from "./img/portfolio-5.jpg";
import project_6 from "./img/portfolio-6.jpg";

function Project() {
  return (
    <div className="project component__space" id="Portfolio">
      <div className="heading">
        <h1 className="heading">My Latest Projects</h1>
        <p className="heading p__color">There are more available Projects...</p>
        <p className="heading p__color">These are major ones!.</p>
      </div>
      <div className="container">
        <div className="row">
          <div className="col__3">
            <div className="project__box pointer relative">
              <div className="project__box__img pointer relative">
                <div className="project__img__box">
                  <img src={project_2} alt="" className="project__img" />
                </div>
                <div className="mask__effect"></div>
              </div>
              <div className="project__meta absolute">
                <h5 className="project__text">Cleaning Company</h5>
                <h4 className="project__text">
                  The Cleaning Company Full Stack App is responsible for
                  delivering a user-friendly and intuitive interface for
                  customers and administrators.
                </h4>
                <a href="https://clean-bg.netlify.app" className="project__btn">
                  View Details
                </a>
              </div>
            </div>
          </div>
          <div className="col__3">
            <div className="project__box pointer relative">
              <div className="project__box__img pointer relative">
                <div className="project__img__box">
                  <img src={project_3} alt="" className="project__img" />
                </div>
                <div className="mask__effect"></div>
              </div>
              <div className="project__meta absolute">
                <h5 className="project__text">Home Food</h5>
                <h4 className="project__text">
                  Helping you enjoy comfortable and healthy food anywhere and
                  anytime.
                </h4>
                <a
                  href="https://homefoodbg.netlify.app"
                  className="project__btn"
                >
                  View Details
                </a>
              </div>
            </div>
          </div>
          <div className="col__3">
            <div className="project__box pointer relative">
              <div className="project__box__img pointer relative">
                <div className="project__img__box">
                  <img src={project_4} alt="" className="project__img" />
                </div>
                <div className="mask__effect"></div>
              </div>
              <div className="project__meta absolute">
                <h5 className="project__text">IFMASA</h5>
                <h4 className="project__text">
                  The Academic State Assembly: Uniting Scholars, Nurturing
                  Excellence, and Empowering Minds to Shape the Future
                </h4>
                <a href="https://ifmasa.netlify.app" className="project__btn">
                  View Details
                </a>
              </div>
            </div>
          </div>
          <div className="col__3">
            <div className="project__box pointer relative">
              <div className="project__box__img pointer relative">
                <div className="project__img__box">
                  <img src={project_5} alt="" className="project__img" />
                </div>
                <div className="mask__effect"></div>
              </div>
              <div className="project__meta absolute">
                <h5 className="project__text">E-commerce</h5>
                <h4 className="project__text">
                  Online stores accessible easily 24/7, providing customers with
                  the flexibility to shop at their convenience, which can lead
                  to increased sales and revenue.
                </h4>
                <a
                  href="https://e-commercebg.netlify.app/"
                  className="project__btn"
                >
                  View Details
                </a>
              </div>
            </div>
          </div>
          <div className="col__3">
            <div className="project__box pointer relative">
              <div className="project__box__img pointer relative">
                <div className="project__img__box">
                  <img src={project_6} alt="" className="project__img" />
                </div>
                <div className="mask__effect"></div>
              </div>
              <div className="project__meta absolute">
                <h5 className="project__text">Baraka's Blog</h5>
                <h4 className="project__text">
                  Connect with like-minded people who share similar interests,
                  passions, or experiences. It fosters a sense of community and
                  belonging within niche or specialized audiences.
                </h4>
                <a href="/" className="project__btn">
                  View Details
                </a>
              </div>
            </div>
          </div>
          <div className="col__3">
            <div className="project__box pointer relative">
              <div className="project__box__img pointer relative">
                <div className="project__img__box">
                  <img src={project_1} alt="" className="project__img" />
                </div>
                <div className="mask__effect"></div>
              </div>
              <div className="project__meta absolute">
                <h5 className="project__text">BMI Calculator</h5>
                <h4 className="project__text">
                  This calculator provides body mass index (BMI) and the
                  corresponding BMI weight status category for adults 20 years
                  and older.
                </h4>
                <a
                  href="https://baraka-bmicalculator.netlify.app"
                  className="project__btn"
                >
                  View Details
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Project;
